// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__XkGLH","yKnotLogo":"NotFoundPage_yKnotLogo__k2O2x","text":"NotFoundPage_text__ucxgo","button":"NotFoundPage_button__c9kFP"};